export const EMAIL_VALIDATE_REGEX =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const SERVER_ADDR = process.env.REACT_APP_SERVER_ADDR;
export const SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
export const SLEEP_TIME = 3000;
export const JWT_TOKEN = 'jwtToken';
export const POST_FILES_FOLDER = 'posts';
export const USER_FILES_FOLDER = 'users';
export const PROPERTY_FILES_FOLDER = 'properties';
